import { useQuery } from 'react-query';
import { iteroProductService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useFetchScannerDetails = (contactId: string, sku: string) => {
  return useQuery(`${ServerStateKeysEnum.scannerDetails} - ${sku}`, () => {
    return iteroProductService.getScannerConfigurations(contactId, sku);
  });
};
